import { Icon, IconType } from "../../../../common/icons/Icon";
import { Referral_Monthly_Discount_Percent } from "../../models/referralProgramModel";
import styles from "./ReferralNavigationItem.module.scss";

interface IReferralNavigationItemProps {
  onClick: () => void;
}

/** The sidebar's last item: opens the referral program instead of a page. */
export const ReferralNavigationItem = ({ onClick }: IReferralNavigationItemProps) => {
  return (
    <button
      type="button"
      className={styles.root}
      onClick={onClick}
      data-onboarding="nav-referral"
    >
      <span className={styles.root_left}>
        {/* Not the gift: that one is "Подаръчни ваучери" */}
        <Icon type={IconType.Megaphone} color={"#fff"} width="34px" height="34px" />
        <span className={styles.root_left_label}>Препоръчай ни</span>
      </span>
      <span className={styles.root_tag}>{Referral_Monthly_Discount_Percent}%</span>
    </button>
  );
};
